import Image from "next/image";
import { useTranslation } from 'next-i18next'

export interface HomeBannerPropsInterface {
  showBtn?: boolean
}

export default function HomeBanner({ showBtn = true }: HomeBannerPropsInterface) {

  const { t } = useTranslation();
  const { i18n } = useTranslation();
  const imgSrc = `/images/rentware/LEON_Banner_Rentware_${i18n.language}.png`;

  return (
    <a href="/grills-und-mehr" className="relative aspect-[2872/605] w-full flex" target="_blank" rel="noreferrer">
        <Image
            src={imgSrc}
            title="Mieten sie"
            alt="Mieten sie"
            fill
            className="w-full rounded-[10px] md:rounded-[30px]"
        />
        <div
					className={`absolute left-1/2 transform -translate-x-1/2 bottom-[8px] sm:bottom-[15px] lg:bottom-[20px] w1440:bottom-[30px] h-4 sm:h-6 lg:h-10  min-w-[75px] sm:min-w-[100px] lg:min-w-[140px] items-center text-sm text-white sm:px-2 justify-center lg:gap-2 rounded-[10px] self-end bg-gradient-to-b from-[#a8e1f7] to-[#43c4f7] hover:bg-leo-dark-brown hover:from-transparent hover:to-transparent transition-all duration-300 ${showBtn ? 'flex' : 'hidden'}`}
				>
					<div className="flex items-center justify-center gap-2 uppercase font-bold text-center w-full">
						<span className="text-[8px] sm:text-[12px] lg:text-[16px]">{t("components.immoCard.details")}</span>
					</div>
				</div>
    </a>
  );
}